import { AbstractFlow3bixaw6q3bbim as AbstractFlow } from './Flow.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ChannelFlowvdfy82kdxy2m as ChannelFlow } from './internal/ChannelFlow.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from '../channels/BufferOverflow.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function flow(block) {
  return new (SafeFlow())(block);
}
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (asFlow$$inlined$unsafeFlow$1())(_this__u8e3s4);
}
var SafeFlowClass;
function SafeFlow() {
  if (SafeFlowClass === VOID) {
    class $ extends AbstractFlow() {
      constructor(block) {
        super();
        this.n1c_1 = block;
      }
      *o1c(collector, $completion) {
        yield* this.n1c_1(collector, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SafeFlow', VOID, VOID, VOID, [1]);
    SafeFlowClass = $;
  }
  return SafeFlowClass;
}
function channelFlow(block) {
  return new (ChannelFlowBuilder())(block);
}
function flowOf(value) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (flowOf$$inlined$unsafeFlow$1())(value);
}
var ChannelFlowBuilderClass;
function ChannelFlowBuilder() {
  if (ChannelFlowBuilderClass === VOID) {
    class $ extends ChannelFlow() {
      constructor(block, context, capacity, onBufferOverflow) {
        context = context === VOID ? EmptyCoroutineContext_instance : context;
        capacity = capacity === VOID ? -2 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        super(context, capacity, onBufferOverflow);
        this.t1c_1 = block;
      }
      u1c(context, capacity, onBufferOverflow) {
        return new (ChannelFlowBuilder())(this.t1c_1, context, capacity, onBufferOverflow);
      }
      *v1c(scope, $completion) {
        return yield* this.t1c_1(scope, $completion);
      }
      toString() {
        return 'block[' + toString(this.t1c_1) + '] -> ' + super.toString();
      }
    }
    initMetadataForClass($, 'ChannelFlowBuilder', VOID, VOID, VOID, [1]);
    ChannelFlowBuilderClass = $;
  }
  return ChannelFlowBuilderClass;
}
var asFlow$$inlined$unsafeFlow$1Class;
function asFlow$$inlined$unsafeFlow$1() {
  if (asFlow$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_asFlow) {
        this.f1d_1 = $this_asFlow;
      }
      *g1d(collector, $completion) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.f1d_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          yield* collector.h1d(element, $completion);
        }
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    asFlow$$inlined$unsafeFlow$1Class = $;
  }
  return asFlow$$inlined$unsafeFlow$1Class;
}
var flowOf$$inlined$unsafeFlow$1Class;
function flowOf$$inlined$unsafeFlow$1() {
  if (flowOf$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($value) {
        this.i1d_1 = $value;
      }
      *g1d(collector, $completion) {
        yield* collector.h1d(this.i1d_1, $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    flowOf$$inlined$unsafeFlow$1Class = $;
  }
  return flowOf$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  asFlow as asFlow3ngsnn5xpz8pw,
  channelFlow as channelFlow1or0c85tk04v1,
  flowOf as flowOf16f7h10nre075,
  flow as flow3tazazxj2t7g4,
};
//endregion

//# sourceMappingURL=Builders.mjs.map
